export default __webpack_public_path__ + "static/media/registration.0fb3374d.svg";